import { useEffect, useState } from 'react'

export function ColorSwatch({ name, cssVar, description }) {
  const [computedValue, setComputedValue] = useState('')

  useEffect(() => {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(cssVar)
      .trim()
    setComputedValue(value)
  }, [cssVar])

  return (
    <div className="flex items-center gap-4 p-3 rounded-lg border bg-card">
      <div
        className="w-12 h-12 rounded-md border shadow-sm shrink-0"
        style={{ backgroundColor: `var(${cssVar})` }}
      />
      <div className="min-w-0">
        <p className="font-mono text-sm font-medium">{name}</p>
        <p className="font-mono text-xs text-muted-foreground truncate">
          {cssVar}
        </p>
        {computedValue && (
          <p className="font-mono text-xs text-muted-foreground">
            {computedValue}
          </p>
        )}
        {description && (
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        )}
      </div>
    </div>
  )
}
